import React from "react";
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    useMediaQuery,
    useTheme,
} from "@mui/material";

import PumpTable from "./components/PumpTable";
import { useDispatch, useSelector } from "react-redux";
import { DateTime } from "luxon";
import {
    requestPumpConnect,
    resetPumps,
    setMinVolume,
    selectPercentPumps,
    selectMarkets,
    selectBybitMarkets,
    selectKrwRate,
    selectMinVolume,
    selectLatestUpdate,
} from "./reducers/pumpReducer";

interface ComponentProps {
}

function KPumps(props: ComponentProps) {

    const dispatch = useDispatch();
    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'));

    const markets = useSelector(selectMarkets);
    const percentPumps = useSelector(selectPercentPumps);
    const bybitMarkets = useSelector(selectBybitMarkets);
    const krwRate = useSelector(selectKrwRate);
    const minVolume = useSelector(selectMinVolume);
    const latestUpdate = useSelector(selectLatestUpdate);

    // Connect on mount (middleware is idempotent — won't reconnect if already up)
    React.useEffect(() => {
        dispatch(requestPumpConnect());
    }, [dispatch]);

    return (
        <Box>
            <Paper elevation={3} sx={{m: isSmall ? 1 : 2, p: isSmall ? 1 : 2}}>
                <Box sx={{display:'flex', alignItems: 'center', justifyContent: 'space-between', mb: isSmall ? 0 : 2}}>
                    <Typography variant={isSmall ? 'body2' : 'body1'}>
                        {isSmall ? '' : 'Last update: '}
                        {DateTime.fromMillis(latestUpdate).toUTC().toFormat(isSmall ? "HH:mm:ss" : "yyyy-MM-dd HH:mm:ss")}Z
                        {' '}({((new Date().valueOf() - latestUpdate)/1000).toFixed(0)}s ago)
                    </Typography>
                    <Button 
                        variant="contained"
                        size={isSmall ? 'small' : 'medium'}
                        onClick={() => dispatch(resetPumps())}
                    >
                        Reset
                    </Button>
                </Box>
                {!isSmall && (
                    <Box sx={{display:'flex', alignItems: 'center', mt: 2}}>
                        <TextField 
                            variant="outlined" 
                            label="Min volume (USDT)" 
                            value={minVolume} 
                            type="number" 
                            onChange={(e) => { dispatch(setMinVolume(parseInt(e.currentTarget.value) || 0)) }} 
                        />
                    </Box>
                )}
            </Paper>
            {
                markets.length > 0
                ? <Paper elevation={3} sx={{m: isSmall ? 1 : 2, p: isSmall ? 1 : 2}}><Typography sx={{fontWeight: 500}} variant="body2">By % movement</Typography>
                    <PumpTable items={percentPumps} krwUSDT={krwRate} sortByVolume={false} bybitMarkets={bybitMarkets} />
                </Paper>
                : null
            }
        </Box>
    );
}

export default KPumps;
